import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, ShoppingCart } from 'lucide-react';
import { Button } from '../../components/ui/button';
import NotificationBell from '../../components/NotificationBell';
import HelpButton from '../../components/client/HelpButton';
import { CartSheet } from './CartSheet';

export const ClientHeader = ({ onOpenSidebar }) => (
  <header className="sticky top-0 z-30 h-16 bg-white border-b flex items-center justify-between px-4 lg:px-6">
    <button className="lg:hidden p-2 -ml-2" onClick={onOpenSidebar} data-testid="mobile-menu-btn">
      <Menu className="h-6 w-6" />
    </button>

    <div className="flex-1 lg:flex-none" />

    {/* Right side actions */}
    <div className="flex items-center gap-3">
      <HelpButton />
      <NotificationBell role="client" />
      <CartSheet />
      <Link to="/client/shop">
        <Button variant="default" size="sm" className="bg-amber-500 hover:bg-amber-600 hidden sm:flex" data-testid="quick-order-btn">
          <ShoppingCart className="h-4 w-4 mr-2" />
          Quick Order
        </Button>
      </Link>
    </div>
  </header>
);
